import { render, staticRenderFns } from "./ModulesGrid.vue?vue&type=template&id=b15b72de"
import script from "./ModulesGrid.vue?vue&type=script&lang=js"
export * from "./ModulesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports